var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0a5590d71eca9422da90a03b8dd541541f581a5a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["found-store@cct-ol"]={id:"0a5590d71eca9422da90a03b8dd541541f581a5a"};
      